import xyglGetter from '../getters/xyglGetter'
import xyglAction from '../actions/xyglAction'
import xyglMutation from '../mutations/xyglMutation'

const xyglModule = {
    state: {
        studys: [],
        studyDetails: {},
        studyLessonAlbumDetails: {},
        studyLessonDetails: {},
        posttestQuestions: [],
        courseExamQuestions: [],
        hgksQuestions: [],
        certLearncert: {},
        personaLprofile: {}
    },
    getters: xyglGetter,
    actions: xyglAction,
    mutations: xyglMutation
}

export default xyglModule;



// WEBPACK FOOTER //
// ./src/store/jzjy/modules/xyglModule.js